import { Footer } from "components/Footer";
import { HeaderWithNav } from "components/HeaderWithNav";
import { HeroSection } from "components/HeroSection";
import { useDynamicLanguage } from "hooks/useDynamicLanguage";
import heroImage from "assets/images/solutions-hero.png";
import { GetStartedSection } from "components/GetStartedSection";
import cardImage2 from "assets/images/solution-image2.png";
import { TextImageSection } from "pages/Products/components/TextImageSection";
import { HowItWorks } from "./components/HowItWorks";
import { LOCALE_STRINGS } from "constants/locales";
import { useScrollToElement } from "hooks/useScrollToElement";
import { TextSection } from "./components/TextSection";

export const Solutions = () => {
  const language = useDynamicLanguage();
  useScrollToElement();

  return (
    <>
      <HeaderWithNav />
      <div id="page" />
      <main className="main-content-wrapper home-page__main">
        <HeroSection
          imageSrc={heroImage}
          language={language}
          titleKey={"hero_solutionsTitle"}
          descriptionKey={"hero_solutionsDescription"}
        />
        <TextSection
          title={LOCALE_STRINGS[language].homePage_solutions_title}
          className="pt-24 pb-10 px-10 mt-6 w-full flex justify-center"
        />

        <TextSection
          title={LOCALE_STRINGS[language].homePage_solutions.trade_title}
          content={LOCALE_STRINGS[language].homePage_solutions.trade_content}
          contentNext={
            LOCALE_STRINGS[language].homePage_solutions.trade_contentNext
          }
        />

        <TextSection
          title={LOCALE_STRINGS[language].homePage_solutions.finance_title}
          content={LOCALE_STRINGS[language].homePage_solutions.finance_content}
        >
          <div className="grid md:grid-cols-2 gap-8 mt-10">
            <div className="p-8 border rounded-xl bg-white/5 transition-hover hover:border-primary">
              <h4 className="mb-3 font-semibold text-xl">
                {
                  LOCALE_STRINGS[language].homePage_solutions
                    .finance_preShipment_title
                }
              </h4>
              <p className="text-image-section-paragraph mb-3">
                {
                  LOCALE_STRINGS[language].homePage_solutions
                    .finance_preShipment_content
                }
              </p>
            </div>

            <div className="p-8 border rounded-xl bg-white/5 transition-hover hover:border-primary">
              <h4 className="mb-3 font-semibold text-xl">
                {
                  LOCALE_STRINGS[language].homePage_solutions
                    .finance_postShipment_title
                }
              </h4>
              <p className="text-image-section-paragraph">
                {
                  LOCALE_STRINGS[language].homePage_solutions
                    .finance_postShipment_content
                }
              </p>
            </div>
          </div>
        </TextSection>

        <HowItWorks language={language} />

        <TextSection
          title={LOCALE_STRINGS[language].homePage_solutions.pay_title}
          content={LOCALE_STRINGS[language].homePage_solutions.pay_content}
          contentNext={
            LOCALE_STRINGS[language].homePage_solutions.pay_contentNext
          }
        />

        <GetStartedSection language={language} />
      </main>
      <Footer />
    </>
  );
};
